export class ChatMessage {

    id: string;
    fromUsuario: string;
    toUsuario: string;
    mensaje: string;
    tipo: string;
    nombre: string;

    constructor(fromUsuario: string = '', toUsuario: string= '', mensaje: string = '', tipo = 'M', nombre: string = '') {
      this.id = '';
      this.fromUsuario = fromUsuario;
      this.toUsuario = toUsuario;
      this.mensaje = mensaje;
      this.tipo = tipo;
      this.nombre = nombre;
    }
  }

  export class ConnectionStatus {
    usuario: string;
    status: string;

    constructor(usuario: string = '', status: string = '') {
      this.usuario = usuario;
      this.status = status;
    }
  }



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/chatMessage.ts